// extracted by mini-css-extract-plugin
export default {"twoFactorContainer":"ModalUserSettings_twoFactorContainer__+Da1n"};